export default {
  // 获取用户总的收益信息
  GET_WALLET_API: '/me/wallet',
  GET_IS_COMPLIANCE: '/common/IsCompliance',
};
